
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import AppMenuCreate from "@/components/AppMenuCreate.vue";
import AppMenuLogo from "@/components/AppMenuLogo.vue";
import AppMenuAccount from "@/components/AppMenuAccount.vue";
import AppMenuNav from "@/components/AppMenuNav.vue";
import AppMenuNavItem from "@/components/AppMenuNavItem.vue";
import BellOutlineIcon from "vue-material-design-icons/BellOutline.vue";
import CogOutlineIcon from "vue-material-design-icons/CogOutline.vue";
import MagnifyIcon from "vue-material-design-icons/Magnify.vue";

@Component({
  components: {
    AppMenuNav,
    AppMenuNavItem,
    AppMenuAccount,
    AppMenuCreate,
    AppMenuLogo,
    BellOutlineIcon,
    CogOutlineIcon,
    MagnifyIcon,
  },
})
export default class AppMenu extends Vue {
  label = null;

  @Prop(String) readonly pageName!: string;

  @Getter getPreferenceByKey: any;

  routeCollapsed: boolean = false;
  isMenuOpened: boolean = false;
  isMenuHidden: boolean = false;

  get isCollapsed() {
    return (
      this.routeCollapsed ||
      this.getPreferenceByKey("menu.expanded") === "collapsed"
    );
  }

  setRouteParams(route: any) {
    this.isMenuHidden = route.meta.isMenuHidden;
    if(!(screen.width <= 640)){
      this.routeCollapsed = route.meta.forceCollapsedMenu;
    }
  }

  @Watch("$route")
  onRouteChanged(to: any, from: any) {
    this.setRouteParams(to);
  }

  mounted() {
    this.setRouteParams(this.$route);
    let self = this;
    this.$root.$on('toggleHamburgerMenu', function(val: boolean = false){
      self.isMenuOpened = val ? !self.isMenuOpened : false;
    })
  }
}
